import { dark_grey } from "colors";

export const styles = {
  title: {
    marginTop: "12px",
    marginBottom: "7px",
    fontSize: "12px",
    textTransform: "uppercase",
  },
  textarea: {
    border: `1px solid ${dark_grey}`,
    borderRadius: "4px",
    resize: "none",
    width: "calc(100% - 25px)",
    height: "100px",
    padding: "10px",
    lineHeight: "20px",
    outlineColor: "#29CC8F",
    marginBottom: "24px",
    fontSize: '16px'
  },
};
